import React, { useEffect, useState, createRef } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { InputLabel } from '@ui-propulsion/react-components';
import Dropdown from '../dropdown/dropdown';
import CtaButton from '../ctaButton/ctaButton';
import heroPrivacySecurityPd from './images/heroPrivacySecurityPd.svg';
import CurrencyInput from '../currencyInput/currencyInput';
import { getNumberFromString } from '../currencyInput/helpers';

import styles from './glossaryHubPrequal.module.scss';

function GlossaryHubPrequal({
  url = '',
  loanPurposes = null,
  contentNote = '',
  title = '',
  inputAmountLabel = '',
  inputAmountPlaceHolder = '',
  submitBtnText = 'Check Your Rate',
  defaultMaxAmount = 40000,
}) {
  const [docked, setDocked] = useState(false);
  const [hasCurrencyError, setHasCurrencyError] = useState('');
  const [hasDropdownError, setHasDropdownError] = useState('');
  const input = createRef();
  const dropdown = createRef();

  const handleSubmit = () => {
    let hasError = false;
    const loanAmount = getNumberFromString(input.current.value);
    const loanPurpose = dropdown.current.value;
    const loanUrl = loanPurposes.find((item) => item.value === loanPurpose);
    const redirectUrl = loanUrl?.url ?? url;
    if (
      loanAmount === '' ||
      loanAmount > defaultMaxAmount ||
      loanAmount < 1000
    ) {
      setHasCurrencyError(
        `Enter $1,000 to $${defaultMaxAmount.toLocaleString()}`
      );
      hasError = true;
    } else {
      setHasCurrencyError('');
    }
    if (loanPurpose === '') {
      setHasDropdownError('Select a loan purpose');
      hasError = true;
    } else {
      setHasDropdownError('');
    }
    if (!hasError)
      window.location.assign(
        `${redirectUrl}?loanAmount=${loanAmount}&loanPurpose=${loanPurpose}`
      );
  };

  useEffect(() => {
    if (window.document.documentElement.scrollTop >= 0 || window.scrollY >= 0) {
      setDocked(true);
    } else {
      setDocked(false);
    }
  }, [docked]);

  return (
    <div
      className={`${styles.glossaryPrequal} ${
        docked && styles.glossaryPrequalDocked
      }`}
    >
      {' '}
      <div className={styles.glossaryPrequalTitle}>{parse(title)}</div>
      <div className={styles.glossaryPrequalText}>{parse(contentNote)}</div>
      <div className={styles.glossaryPrequalForm}>
        <div className={styles.glossaryPrequalHorizontalForm}>
          <div className={styles.glossaryPrequalContainer}>
            <InputLabel required>{inputAmountLabel}</InputLabel>
            <div className={styles.inputAmountGrid}>
              <CurrencyInput
                className="currencyInput"
                ref={input}
                hasError={hasCurrencyError}
                placeholder={inputAmountPlaceHolder}
              />
            </div>
            <div className={styles.dowpdownGrid}>
              <Dropdown
                ref={dropdown}
                options={loanPurposes}
                errorMessage={hasDropdownError}
                className="heroHomeDropdown"
                elevation
              />
            </div>
            <div className={styles.ctaGrid}>
              <CtaButton
                label={submitBtnText}
                variant="primary"
                type="submit"
                data-testid="check-rate"
                aria-label="submit-rate"
                onClick={handleSubmit}
                fullWidth
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.glossaryPrequalActionsImage}>
        {heroPrivacySecurityPd && (
          <img
            src={heroPrivacySecurityPd.src}
            loading="lazy"
            alt={`${parse(title)} Privacy & Security`}
            height={100}
            width={100}
          />
        )}
      </div>
    </div>
  );
}

GlossaryHubPrequal.propTypes = {
  url: PropTypes.string,
  loanPurposes: PropTypes.arrayOf(PropTypes.object),
  contentNote: PropTypes.string,
  title: PropTypes.string,
  inputAmountLabel: PropTypes.string,
  inputAmountPlaceHolder: PropTypes.string,
  submitBtnText: PropTypes.string,
};

export default GlossaryHubPrequal;
